import React from 'react';
import "../../styles/details.css";

interface DescriptionListProps {
  text: string;
}

const DescriptionList: React.FC<DescriptionListProps> = ({ text }) => {
  const lines = text.split('/n');

  return (
    <h5>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </h5>
  );
};

export default DescriptionList;